import { render, staticRenderFns } from "./TermsAndConditionsPage.fr-be.vue?vue&type=template&id=766e3edc"
import script from "./TermsAndConditionsPage.fr-be.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPage.fr-be.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports